import { Center, Environment, OrbitControls } from "@react-three/drei";
import { Canvas } from "@react-three/fiber";
import { NeutralToneMapping } from "three";
import LoadStatus from "./LoadStatus";
import { useState, createContext } from "react";
import MaterialModel from "./MaterialModel";
import { Collapse } from "antd";
import MaterialDebugPanel from "./MaterialDebugPanel";
import MaterialInspectorContext from "../contextFiles/MaterialInspectorContext";

const Material_Inspector = ({materialDebugMode}) => {
    const id = window.location.search.split("?id=")[1];
    const [loaded, setLoaded] = useState(false);
    const [verticalRepeat, setVerticalRepeat] = useState(0);
    const [horizontalRepeat, setHorizontalRepeat] = useState(0);
    const [repeatLock, setRepeatLock] = useState(true);

    return (
        <MaterialInspectorContext.Provider value={{ horizontalRepeat, verticalRepeat, setHorizontalRepeat, setVerticalRepeat, repeatLock, setRepeatLock, setLoaded }}>
            <div className={`canvas-container ${loaded ? 'loaded' : 'loading'}`}>
                <Canvas
                    gl={{ toneMapping: NeutralToneMapping, toneMappingExposure: 1 }}
                    flat
                    shadows
                    camera={{ fov: 20 }}>
                    <Environment files={'./env/neutral.hdr'} />
                    <Center>
                        <MaterialModel id={id} />
                    </Center>
                    <OrbitControls 
                        autoRotate={false} 
                        enablePan={true} 
                        enableDamping={true}
                        minDistance={0.75}  // Minimum zoom distance
                        maxDistance={8}    // Maximum zoom distance
                    />
                </Canvas>
            </div>
            {!loaded && (
                <div className="loading-overlay">
                    <LoadStatus loadingText={"Loading Textures..."} />
                </div>
            )}
            {materialDebugMode && (
                <div className="inspectorPanel">
                    <Collapse>
                        <Collapse.Panel style={{ fontSize: "small" }} header="Debug Modes" key="1">
                            <MaterialDebugPanel/>
                    </Collapse.Panel>
                    </Collapse>
                </div>
            )}
        </MaterialInspectorContext.Provider>
    );
};

export default Material_Inspector;